<template lang="pug">
app-modal(
    :closeOutside="false",
    titulo="Termo de compromisso",
    :width="700",
    :height="580"
    @closeModal="$emit('cancelar')"
  )
    template(slot="body")
      .modal-body-termo
        termo-compromisso
        .termo-aceite
          el-checkbox.check(v-model="isAceito")
            span(v-html="textoTermoAceite")
    template(slot="footer")
      div.buttons
        el-button.btn-cancelar(
          type="default",
          @click="$emit('cancelar')"
        )
          i.fal.fa-times
          span &nbsp Cancelar
        el-button(
          type="primary",
          @click="$emit('confirmar')"
          :disabled="!isAceito"
        )
          i.fal.fa-check
          span &nbsp Confirmar
</template>

<script>
import AppModal from '@/components/AppModal'
import axios from '@/utils/api'
import { mapState } from 'vuex'
const TermoCompromisso = () => import('@/components/estados/' + process.env.ESTADO + '/TermoCompromisso')

export default {
  components: {
    AppModal,
    TermoCompromisso
  },

  async mounted () {
    const result = await axios({
      method: 'GET',
      url: 'central/termoCompromisso'
    })
    this.textoTermo = result.texto
  },

  props: {
    imovel: {
      required: true
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      isAceito: false,
      textoTermo: ''
    }
  },
  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),

    textoTermoAceite () {
      if (this.isProcessoFisico) {
        return 'Declaro que li e estou de acordo com os termos acima e tenho' +
        ' ciência que ao finalizar este cadastro ele será enviado automaticamente' +
        ` para o ITERMA para início do processo de regularização.`
      }
      return 'Declaro que li e estou de acordo com os termos acima e tenho' +
        ' ciência que ao finalizar este cadastro ele será enviado automaticamente' +
        ` para o ${this.ORGAO} para início do processo de cancelamento.`
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.texto {
  padding: 10px;
  background-color: #f3f7fa;
  border-radius: 15px;
  color: #000;
  p {
    font-size: 15px;
  }
}

.termo-aceite {
  margin-top: 10px;
}

.modal-header p {
  color: $color-primary !important;
}

.check {
  margin-right: 2%;
  display: flex;
  align-items: center;
  white-space: normal;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.modal-body-termo {
  padding: 0px 20px;
}

.btn-cancelar {
  &:hover {
    background-color: #fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/TermoCompromissoSicarf.vue